import ViewVehicle from '../../components/vehicles/viewVehicle/ViewVehicle'
import { connect } from 'react-redux'
import { IStoreState } from '../../types'
// import * as actions from '../../state/actions/vehicles'
import { getSingleVehicle, activateVehicle, deactivateVehicle } from '../../state/actions/vehicles'
import { RouteComponentProps } from 'react-router'
import { fetchProductsByOrganizationId } from '../../state/actions/provider-products'
import { AnyAaaaRecord } from 'dns'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<{ id: string }>) {
  const test = state.vehicles.items[ownProps.match.params.id]

  return {
    ...ownProps,
    organizationId: state.organizations.currentOrgId || '',
    vehicle: state.vehicles.items[ownProps.match.params.id],
    providerProduct: state.providerProduct.items
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getVehicle: (id: string) => dispatch(getSingleVehicle(id)),
    deactivateVehicle: (vehicleId: string) => dispatch(deactivateVehicle(vehicleId)),
    activateVehicle: (vehicleId: string) => dispatch(activateVehicle(vehicleId)),
    fetchProductsByOrganizationId: (organizationId: string) => {
      const dto = {
        organizationId,
        skip: 0,
        take: 9999, // get all existing products
        active: true
      }
      dispatch(fetchProductsByOrganizationId(dto))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewVehicle)



// WEBPACK FOOTER //
// ./src/containers/vehicles/ViewVehicle.ts